import dayjs from 'dayjs';

// 日付ラベルを取得する
// 今年の場合は年表記を除外する
// 例：（2024の場合）Dec 28, 30, Mar 7, 8, 2025
export const formatDateLabel = (dates: dayjs.Dayjs[]): string => {
  const currentYear = dayjs().year().toString();
  let formattedLabel = '';
  let currentYearMonth = '';
  let yearLabel = '';

  for (const date of dates) {
    const targetDate = date.tz().locale('en');
    const year = targetDate.format('YYYY');
    const month = targetDate.format('MMM');
    const day = targetDate.format('D');
    let monthYearLabel = '';

    // 月が変わったら、月ラベルを追加
    if (currentYearMonth !== year + month) {
      // 年ラベルを月ラベルの前に追加
      monthYearLabel = `${yearLabel} ${month}`;

      // 今年の場合は年ラベルを追加しない
      if (year !== currentYear) {
        yearLabel = ` ${year},`;
      }
    }

    formattedLabel += `${monthYearLabel} ${day},`;
    currentYearMonth = year + month;
  }
  // 年ラベルを末尾に追加
  formattedLabel += yearLabel;
  // 先頭のスペース、末尾のカンマ、スペースを削除
  formattedLabel = formattedLabel.trim().replace(/,$/, '');

  return formattedLabel;
};
